(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["stressbollen-frakt-bundle"] && !Shopify.designMode) return;
  try {
    (() => {
  const drawer = document.querySelector('[data-frakt-cart-drawer]');
  if (drawer && !drawer.dataset.fraktCartDrawerReady) {
    drawer.dataset.fraktCartDrawerReady = 'true';
    const closeDrawer = () => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden','true');
      document.body.classList.remove('frakt-cart-drawer-open');
    };
    drawer.querySelectorAll('[data-frakt-cart-close]').forEach(el => el.addEventListener('click', closeDrawer));
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
  }

  document.querySelectorAll('[data-bundle-builder]').forEach(root => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const maxItems = 5;
    const bundlePrice = 50000;
    const bundleVariantId = String(root.dataset.bundleVariant || '');
    const selected = [];
    const countEl = root.querySelector('[data-bundle-count]');
    const progressEl = root.querySelector('[data-bundle-progress]');
    const slotsEl = root.querySelector('[data-bundle-slots]');
    const priceEl = root.querySelector('[data-bundle-price]');
    const savingEl = root.querySelector('[data-bundle-saving]');
    const submit = root.querySelector('[data-bundle-submit]');
    const statusEl = root.querySelector('[data-bundle-status]');

    const money = cents => new Intl.NumberFormat('sv-SE',{
      style:'currency',currency:'SEK',maximumFractionDigits:0
    }).format(cents / 100);

    function render() {
      countEl.textContent = selected.length;
      progressEl.textContent = selected.length === maxItems ? 'Klart! Paketet är redo.' : (maxItems - selected.length) + ' val kvar';
      slotsEl.innerHTML = '';

      for (let i = 0; i < maxItems; i++) {
        const slot = document.createElement('div');
        slot.className = 'frakt-bundle-slot' + (selected[i] ? ' is-filled' : '');

        if (selected[i]) {
          const inner = document.createElement('div');
          inner.className = 'frakt-bundle-slot__inner';

          if (selected[i].image) {
            const img = document.createElement('img');
            img.src = selected[i].image;
            img.alt = '';
            inner.appendChild(img);
          } else {
            inner.appendChild(document.createElement('div'));
          }

          const textWrap = document.createElement('span');
          const name = document.createElement('strong');
          name.textContent = selected[i].label;
          const small = document.createElement('small');
          small.textContent = money(selected[i].price);
          const remove = document.createElement('button');
          remove.type = 'button';
          remove.textContent = 'Ta bort';
          remove.addEventListener('click', () => {
            selected.splice(i, 1);
            render();
          });

          textWrap.append(name, small, remove);
          inner.appendChild(textWrap);
          slot.appendChild(inner);
        } else {
          slot.textContent = 'Val ' + (i + 1);
        }

        slotsEl.appendChild(slot);
      }

      root.querySelectorAll('.sbcro-bundle-card').forEach(card => {
        const select = card.querySelector('[data-bundle-variant-select]');
        const countBadge = card.querySelector('[data-bundle-card-count]');
        const ids = Array.from(select?.options || []).map(o => String(o.value));
        const count = selected.filter(item => ids.includes(String(item.id))).length;
        card.classList.toggle('is-selected', count > 0);
        if (countBadge) countBadge.textContent = count > 1 ? '×' + count : '✓';
        const addButton = card.querySelector('[data-bundle-add]');
        if (addButton) addButton.textContent = count > 0 ? '+ Välj igen' : '+ Välj';
      });

      const regular = selected.reduce((sum,item) => sum + item.price,0);

      if (selected.length < maxItems) {
        priceEl.textContent = money(regular);
        savingEl.textContent = 'Välj fem för att se paketpriset.';
        submit.disabled = true;
        submit.textContent = 'Välj 5 squishys först';
      } else {
        const finalPrice = Math.min(regular,bundlePrice);
        priceEl.textContent = money(finalPrice);
        submit.disabled = false;

        if (regular > bundlePrice) {
          savingEl.textContent = 'Ordinarie ' + money(regular) + ' · du sparar ' + money(regular - bundlePrice);
          submit.textContent = 'Lägg paketet i varukorgen – 500 kr';
        } else {
          savingEl.textContent = 'Din kombination är billigare än 500 kr – du får det lägre priset.';
          submit.textContent = 'Lägg 5 i varukorgen – ' + money(regular);
        }
      }
    }

    root.querySelectorAll('[data-bundle-add]').forEach(button => {
      button.addEventListener('click', () => {
        if (selected.length >= maxItems) {
          statusEl.textContent = 'Du har redan valt fem. Ta bort ett val för att byta.';
          return;
        }

        const card = button.closest('.sbcro-bundle-card');
        const select = card.querySelector('[data-bundle-variant-select]');
        const option = select.options[select.selectedIndex];
        if (!option) return;

        selected.push({
          id:String(option.value),
          price:Number(option.dataset.price || 0),
          label:option.dataset.label || select.dataset.productTitle,
          handle:select.dataset.productHandle || '',
          image:select.dataset.productImage || ''
        });

        statusEl.textContent = '✓ ' + selected[selected.length - 1].label + ' är vald. ' + (maxItems - selected.length) + ' val kvar.';
        render();
      });
    });

    submit.addEventListener('click', async () => {
      if (selected.length !== maxItems) return;

      submit.disabled = true;
      const originalText = submit.textContent;
      submit.textContent = 'Lägger till…';
      statusEl.textContent = 'Vi lägger paketet i varukorgen…';

      const regular = selected.reduce((sum,item) => sum + item.price,0);
      let items;

      if (regular > bundlePrice) {
        const properties = {'Paket':'5 valfria squishys för 500 kr'};
        selected.forEach((item,index) => {
          properties[(index+1)+'. Vald squishy'] = item.label;
          properties['_'+(index+1)+'_variant_id'] = String(item.id);
          properties['_'+(index+1)+'_handle'] = item.handle;
        });
        items = [{id:bundleVariantId,quantity:1,properties}];
      } else {
        const qty = new Map();
        selected.forEach(item => qty.set(item.id,(qty.get(item.id)||0)+1));
        items = Array.from(qty,([id,quantity]) => ({id,quantity}));
      }

      try {
        const response = await fetch('/cart/add.js',{
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items})
        });
        if (!response.ok) throw new Error('cart');
        const cartResponse = await fetch('/cart.js',{headers:{'Accept':'application/json'}});
        const cart = await cartResponse.json();

        const cartBtn = document.querySelector('#sq-cart-btn');
        if (cartBtn) {
          let badge = cartBtn.querySelector('span');
          if (!badge) {
            badge = document.createElement('span');
            cartBtn.appendChild(badge);
          }
          badge.textContent = String(cart.item_count || 0);
          badge.hidden = !cart.item_count;
        }

        document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
        selected.splice(0, selected.length);
        render();
        statusEl.textContent='✓ Paketet är tillagt – fortsätt gärna shoppa.';

      } catch (error) {
        statusEl.textContent='Något gick fel. Försök igen.';
        submit.disabled=false;
        submit.textContent=originalText;
      }
    });

    render();
  });
})();
  } catch(e) { console.error(e); }
})();

})();
